/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 14:52:40
 * @LastEditTime: 2020-11-21 18:33:08
 * @LastEditors: wutt
 */
import { UCModuleItemType } from "./sideBar/UCSideBarJs";
import { UCPOIResultParams } from "./POISearch/UCPOISearchJs";
import { GeometryExtentUtility } from "../../utility/common/GeometryExtentUtility";
import { GeometryUtility } from "../../utility/common/GeometryUtility";
import { POIResultItems, POISurroundType, POIResultItem } from "./model/POISearch";
import { MapBaseLayerType } from "./mainMap/layer/MapBaseLayer";
import { RouteLayer } from "./mainMap/layer/RouteLayer";
import { RouteSearchParams, RoutePOIInfo } from "./route/UCRouteJs";
import { DrawGeometry, DrawGeometryType } from "./model/DrawGeometryJs";
import { ReverseAddress } from "./model/ReverseAddress.js";
import { UserCollectItem } from "./model/UserCollectJs";
import { DateUtility } from "../../utility/common/DateUtility";
import { ServiceUrlConfig } from "../../config/ServiceUrlConfigJs";
import { DrawGeometryLayer } from "./mainMap/layer/DrawGeometryLayer";
import { TdtUser } from "./model/TdtUserJs.js";
import { MainMapInfo, MapToolType } from "./model/MainMapInfo";
import { POISearchLayer } from "./mainMap/layer/POISearchLayer";
import { LayerFeatureType } from "./mainMap/layer/LayerFeatureType";



export class UCOnlineMap {

}


export class UCOnlineMapEventManager {
    constructor() {
        this.ucMap = null;
        this.ucSideBar = null;
        this.ucNavBar = null;
        this.ucLayerSwitch = null;

        this.ucZoomControl = null;

        this.ucMapBottomLeft = null;

    }


    // /**
    //  * 展示导航条
    //  */
    // showRouteBar() {
    //     let self = this;
    //     //初始化标记图层
    //     self.ucMap.layerMgr.clearMarkers();
    //     self.ucSideBar.showModule(UCModuleItemType.routeline, null);
    // }


    /**
     * 追加事件监听
     */
    addListener() {

        this._addUCMapListener();

        this._addNavBarListener();

        this._addUCPOISearchListener();

        this._addUcRouteListener();

        this._addUcCollectListener();

        this._addUcLayerSwitchListener();




        this._addZoomControlListener();

    }

    _addNavBarListener() {
        let self = this;

        this.ucNavBar.on_switch_routeLine(function () {
            //初始化标记图层
            self.ucMap.layerMgr.clearMarkers();
            self.ucSideBar.showModule(UCModuleItemType.routeline, null);
        }
        );

        this.ucNavBar.on_cityPickerChanger(function (curDistrict) {
            if (curDistrict) {
                self.ucMap.layerMgr.districtLayer.location(curDistrict);
            }

        });


        this.ucNavBar.on_measureDistanceToolClick(function () {
            self.ucMap.curMap.changeDragMode("measureLine", function (callbackData) {
                // let data=callbackData;
                // MainMapInfo.currentTool=MapToolType.unknown;
            });
        });

        this.ucNavBar.on_measureAreaToolClick(function () {
            self.ucMap.curMap.changeDragMode("measureArea", function (callbackData) {
                // let data=callbackData;
                // MainMapInfo.currentTool=MapToolType.unknown;
            });
        });


        this.ucNavBar.on_drawPointToolClick(function () {

            self.ucMap.curMap.changeDragMode("drawPoint", function (e) {
                // MainMapInfo.currentTool=MapToolType.unknown;

                let drawGeometry = new DrawGeometry();
                drawGeometry.type = DrawGeometryType.point;
                drawGeometry.coordString = e.coordString;
                let coordinatesString = e.coordString.split(',');

                let coordinateXString = coordinatesString[0];
                let coordinateYString = coordinatesString[1];

                let coordinateX = parseFloat(coordinateXString);
                let coordinateY = parseFloat(coordinateYString);

                let coordinates = [coordinateX, coordinateY];

                drawGeometry.coordinates = coordinates;

                if (TdtUser.envIsPublic) {
                    //调用天地图逆地理编码
                    ReverseAddress.getAddress(coordinateX, coordinateY, function (addressInfo) {
                        if (addressInfo) {
                            drawGeometry.name = addressInfo.poi;
                        }

                        self.ucMap.layerMgr.drawGeometryLayer.addDrawPoint(drawGeometry);

                        let initFeature = DrawGeometryLayer.createInitFeature(drawGeometry);
                        self.ucMap.showOverlay(coordinates, initFeature);

                    },
                        function (error) {

                            self.ucMap.layerMgr.drawGeometryLayer.addDrawPoint(drawGeometry);
                            let initFeature = DrawGeometryLayer.createInitFeature(drawGeometry);
                            self.ucMap.showOverlay(coordinates, initFeature);

                        });
                }
                else {
                    self.ucMap.layerMgr.drawGeometryLayer.addDrawPoint(drawGeometry);
                    let initFeature = DrawGeometryLayer.createInitFeature(drawGeometry);
                    self.ucMap.showOverlay(coordinates, initFeature);
                }

            });

        });


        this.ucNavBar.on_drawPolylineToolClick(function () {
            self.ucMap.curMap.changeDragMode("drawPolyline", function (e) {

                // MainMapInfo.currentTool=MapToolType.unknown;

                let drawGeometry = new DrawGeometry();
                drawGeometry.type = DrawGeometryType.polyline;
                drawGeometry.coordString = e.coordString;

                let pnts = GeometryUtility.getPointsEx2(e.coordString);
                let transfermPnts = pnts;
                let mapCode = self.ucMap.getProjectionCode();
                let crsCode = drawGeometry.crsCode;

                if (mapCode !== crsCode) {
                    transfermPnts = GeometryUtility.transformPoints(pnts, crsCode, mapCode);
                }

                drawGeometry.coordinates = transfermPnts;

                self.ucMap.layerMgr.drawGeometryLayer.addDrawPolyline(drawGeometry);

                let selectPnt = transfermPnts[Math.round(transfermPnts.length / 2)];
                let initFeature = DrawGeometryLayer.createInitFeature(drawGeometry);
                self.ucMap.showOverlay(selectPnt, initFeature);

            });

        });

        this.ucNavBar.on_drawPolygonToolClick(function () {
            self.ucMap.curMap.changeDragMode("drawPolygon", function (e) {

                // MainMapInfo.currentTool=MapToolType.unknown;

                let drawGeometry = new DrawGeometry();
                drawGeometry.type = DrawGeometryType.polygon;
                drawGeometry.coordString = e.coordString;

                let pnts = GeometryUtility.getPointsEx2(e.coordString);
                let transfermPnts = pnts;
                let mapCode = self.ucMap.getProjectionCode();
                let crsCode = drawGeometry.crsCode;

                if (mapCode !== crsCode) {
                    transfermPnts = GeometryUtility.transformPoints(pnts, crsCode, mapCode);
                }

                drawGeometry.coordinates = transfermPnts;
                self.ucMap.layerMgr.drawGeometryLayer.addDrawPolygon(drawGeometry);

                let selectPnt = transfermPnts[Math.round(transfermPnts.length / 2)];
                let initFeature = DrawGeometryLayer.createInitFeature(drawGeometry);
                self.ucMap.showOverlay(selectPnt, initFeature);

            });

        });


        //点击用户收藏
        this.ucNavBar.on_userCollectClick(function () {
            self.ucMap.layerMgr.clearMarkers();
            self.ucSideBar.showModule(UCModuleItemType.userCollect, null);
        });




        this.ucNavBar.on_clearToolClick(function () {
            self.ucMap.layerMgr.clearMarkers();
            self.ucSideBar.clearContent();
            self.ucSideBar.hidden();
        }
        );

        this.ucNavBar.on_fullscreenClick(function () {

            self.ucMap.fullscreen();

        });


    }


    _addUCPOISearchListener() {
        let self = this;
        //ucpoi搜索-结果改变
        self.ucSideBar.curUCPOIResult.on_searchResultChange(function (pois) {

            self.ucNavBar.hiddenUCSuggestKey();

            self._addpoiMarkers(pois);
        });


        self.ucSideBar.curUCPOIResult.on_poiItemClick(function (curPoi) {
            self._locationPoiMarker(curPoi);
        });

        self.ucSideBar.curUCPOIResult.on_poiItemMouseOver(function (curPoi) {
            self._changeFocusPoiMarkerStyle(curPoi);
        });

        self.ucSideBar.curUCPOIResult.on_poiItemMouseOut(function (curPoi) {
            self._changeFocusPoiMarkerStyle(curPoi);
        });

        //建议词poi单击
        self.ucNavBar.on_suggestPoiItemClick(function (suggestPoi) {
            let poiResultParams = new UCPOIResultParams();
            poiResultParams.commonPoi = suggestPoi;

            self.ucNavBar.hiddenUCSuggestKey();

            //初始化标记图层
            self.ucMap.layerMgr.clearMarkers();

            self.ucSideBar.showModule(UCModuleItemType.poiResult, poiResultParams);
        });

        //poi搜索单击
        self.ucNavBar.on_poiSearchClick(function (fuzzyKey) {
            let poiResultParams = new UCPOIResultParams();
            poiResultParams.fuzzyKey = fuzzyKey;

            //初始化标记图层
            self.ucMap.layerMgr.clearMarkers();


            self.ucSideBar.showModule(UCModuleItemType.poiResult, poiResultParams);
        });
    }


    _addUcRouteListener() {
        let self = this;

        self.ucSideBar.curUCRoute.on_searchInput_searchClick(function () {
            //初始化标记图层
            self.ucMap.layerMgr.clearMarkers();
        }
        );


        //驾车线路搜索完成
        self.ucSideBar.curUCRoute.on_drive_routeSearchFinished(function (route) {

            self._addDriveRouteLineFeature(route);
        });

        //驾车线路项单击
        self.ucSideBar.curUCRoute.on_drive_routeItemClick(function (routeItem) {
            self._addDriveRouteSelectLineFeature(routeItem);
        });

        self.ucSideBar.curUCRoute.on_bus_busTransferInfoSearchFinished(function () {
            self.ucMap.layerMgr.clearMarkers();
        });


        self.ucSideBar.curUCRoute.on_bus_lineItemClick(function (lineItem) {
            self._addBusLineFeature(lineItem);
        });

        self.ucSideBar.curUCRoute.on_bus_segmentItemClick(function (segmentItem) {
            self._addBusSegmentFeature(segmentItem);
        });


        self.ucSideBar.curUCRoute.on_bus_segmentEndNameClick(function (segmentItem) {
            self._focusedBusSegmentEnd(segmentItem);
        });


        self.ucSideBar.curUCRoute.on_routeSearchTypeChange(function () {
            self.ucMap.layerMgr.clearMarkers();
        }
        );

        self.ucSideBar.curUCRoute.on_clearRoute(function () {
            self.ucMap.layerMgr.clearMarkers();
        }
        );


        self.ucSideBar.curUCRoute.on_drive_poiSearchFinished(function (pois) {
            self._addpoiMarkers(pois);
        });

    }

    _addUcCollectListener() {

        let self = this;

        self.ucSideBar.curUCCollect.on_ucCollectItem_nodeCheckedChange(function (collectItem) {
            if (!collectItem) return;

            let itemChecked = collectItem.checked;

            let contentString = collectItem.content;
            let collectItemContent = JSON.parse(contentString);
            let drawGeometry = DrawGeometry.fromJson(collectItemContent);

            if (itemChecked) {
                self.ucMap.layerMgr.drawGeometryLayer.addCollectGeometry(drawGeometry);
            }
            else {
                self.ucMap.layerMgr.drawGeometryLayer.deleteDrawGeometry(drawGeometry);
                //清除overlay
                self.ucMap.clearOverlays();
            }
        });

        self.ucSideBar.curUCCollect.on_ucCollectItem_deleteNode(function (collectItem) {
            if (!collectItem) return;

            let contentString = collectItem.content;
            let collectItemContent = JSON.parse(contentString);
            let drawGeometry = DrawGeometry.fromJson(collectItemContent);

            self.ucMap.layerMgr.drawGeometryLayer.deleteCollectGeometry(drawGeometry);
            //清除overlay
            self.ucMap.clearOverlays();
        });

    }



    _addUcLayerSwitchListener() {
        let self = this;

        //切换矢量
        self.ucLayerSwitch.on_switchVectorClick(function () {
            self.ucMap.layerMgr.baseLayer.showVisibleLayer(MapBaseLayerType.Vector);
        }

        );

        //切换影像
        self.ucLayerSwitch.on_switchImageClick(function () {
            self.ucMap.layerMgr.baseLayer.showVisibleLayer(MapBaseLayerType.Image);
        }
        );

        //切换地形
        self.ucLayerSwitch.on_switchTerClick(function () {
            self.ucMap.layerMgr.baseLayer.showVisibleLayer(MapBaseLayerType.Ter);
        });

    }

    /**
     * 添加地图服务树监听
     */
    _addUCMapServicetTreeListener() {
        let self = this;

        self.ucServiceTree.on_nodeItemCheckChange(function (mapServices) {
            self.ucMap.layerMgr.mapServiceLayer.addLayer(mapServices);



        });

    }


    // _addUCDistrictListener() {
    //     let self = this;

    //     self.ucDistrict.on_cityPickerChanger(function (curDistrict) {
    //         self.ucMap.layerMgr.districtLayer.location(curDistrict);
    //     });

    // }

    _addUCMapListener() {
        let self = this;

        this.ucMap.on_mapClick(function (e) {
            //当前地图如果为地图右键，单击地图左键隐藏当前overlay
            if (MainMapInfo.currentTool === MapToolType.button_rightClick) {
                self.ucMap.hideOverlay();
                MainMapInfo.currentTool = MapToolType.unknown;
            }

            let pixel = self.ucMap.curMap.getEventPixel(e.originalEvent);
            self.ucMap.curMap.forEachFeatureAtPixel(pixel, function (feature) {
                if (!feature) {
                    return;
                }

                //点击poi时，会执行两次
                let coodinate = e.coordinate;
                self.ucMap.showOverlay(coodinate, feature);
            });
        });

        if (TdtUser.envIsPublic) {
            this.ucMap.on_rightClick(function (event) {
                event.preventDefault();//屏蔽自带的右键事件

                //地图工具中，部分已使用了右键功能，不能触发地图右键菜单
                if (MainMapInfo.currentTool === MapToolType.tool_drawPolygon
                    || MainMapInfo.currentTool === MapToolType.tool_drawPolyline
                    || MainMapInfo.currentTool === MapToolType.tool_measureDistance
                    || MainMapInfo.currentTool === MapToolType.tool_measureArea) {
                    MainMapInfo.currentTool = MapToolType.unknown;
                    return;
                }

                //将当前工具设置为右键菜单
                MainMapInfo.currentTool = MapToolType.button_rightClick;


                let eventCoordinate = self.ucMap.curMap.getEventCoordinate(event);


                let mapInfo = new MainMapInfo();
                mapInfo.overlayPoint = eventCoordinate;

                let tempFeature = new ol.Feature(
                    {
                        geometry: null,
                        featureType: LayerFeatureType.map_right_hand_button,
                        featureTypeIsOverlay: true,
                        bindingObject: mapInfo
                    }
                )

                self.ucMap.showOverlay(eventCoordinate, tempFeature);

            });

        }



        this.ucMap.on_mapPointerMove(function (e) {
            let pixel = self.ucMap.curMap.getEventPixel(e.originalEvent);
            let curFeature = self.ucMap.curMap.forEachFeatureAtPixel(pixel, function (feature) {
                return feature;
            });

            if (!curFeature) {
                //修改鼠标形状
                self.ucMap.curMap.getTargetElement().style.cursor = "default";
            }
            else {
                //修改鼠标形状
                self.ucMap.curMap.getTargetElement().style.cursor = "pointer";
            }

            //刷新左下角显示的坐标
            self.ucMapBottomLeft.refreshCoordinate(e.coordinate);

        });

        this.ucMap.on_ucOverlay_getSurroundInfoFinished(function (surroundInfo) {
            if (!surroundInfo) return;
            
            let surroundType = surroundInfo.surroundType;
            let curPOI = surroundInfo.poi;


            if (surroundType === POISurroundType.type_POI) {
                let poiResultParams = new UCPOIResultParams();
                poiResultParams.fuzzyKey = surroundInfo.surroundPOIFuzzyKey;
                poiResultParams.centerPoi = curPOI;
                self.ucSideBar.showModule(UCModuleItemType.poiResult, poiResultParams);
            }
            else {

                let poiName = curPOI.name;
                let routeSearchParams = new RouteSearchParams();

                if (surroundType === POISurroundType.type_route_endPOI) {
                    let endPOIInfo = RoutePOIInfo.createEndPoint();
                    endPOIInfo.suggestKey = poiName;
                    endPOIInfo.POI=curPOI;
                    routeSearchParams.endPoint = endPOIInfo;
                }
                else if (surroundType === POISurroundType.type_route_startPOI) {

                    let startPOIInfo = RoutePOIInfo.createStartPoint();
                    startPOIInfo.suggestKey = poiName;
                    startPOIInfo.POI=curPOI;
                    routeSearchParams.startPoint = startPOIInfo;
                }
                else if (surroundType === POISurroundType.type_route_viaPOI) {
                    let viaPoints = new Array();
                    let viaPnt = null;
                    viaPnt = RoutePOIInfo.createViaPoint();
                    viaPnt.POI=curPOI;
                    viaPnt.suggestKey = poiName;
                    viaPoints.push(viaPnt);
                    routeSearchParams.driveViaPoints = viaPoints;
                }

                self.ucSideBar.showModule(UCModuleItemType.routeline, routeSearchParams);
            }

            self.ucMap.layerMgr.clearMarkers();
        }
        );

        this.ucMap.on_ucOverlay_on_saveDrawGeometry(function (drawGeometry) {
            if (!drawGeometry) return;

            self.ucMap.layerMgr.drawGeometryLayer.saveGeometry(drawGeometry);

            //清除overlay
            self.ucMap.clearOverlays();
        });

        //删除标绘图形
        this.ucMap.on_ucOverlay_on_deleteDrawGeometry(function (drawGeometry) {
            self.ucMap.layerMgr.drawGeometryLayer.deleteDrawGeometry(drawGeometry);
            //清除overlay
            self.ucMap.clearOverlays();
        });


        this.ucMap.on_ucOverlay_selectCollectFolderFinished(function (curFolder, drawItem) {

            self._addCollectItemHandler(curFolder, drawItem, function (response) {

            }, function (error) {

            });

        });



        this.ucMap.on_ucOverlay_mapRightButton_getPOIInfoFinished(function (surroundInfo) {

            if (!surroundInfo) return;

            let surroundType = surroundInfo.surroundType;
            let curPOI = surroundInfo.poi;

            //调用天地图逆地理编码
            ReverseAddress.getAddress(curPOI.x, curPOI.y, function (addressInfo) {

                if (surroundType === POISurroundType.type_POI) {

                    if (addressInfo) {
                        curPOI.name = addressInfo.poi;
                        curPOI.address = addressInfo.formattedAddress;
                    }

                    let initFeature = POISearchLayer.createInitFeature(curPOI);
                    let coordinates = [curPOI.x, curPOI.y];

                    self.ucMap.showOverlay(coordinates, initFeature);
                }
                else {

                    let addressPOI = POIResultItem.fromAddressInfo(addressInfo);

                    //获取原始输入参数
                    let routeSearchParams = self.ucSideBar.curUCRoute.getSearchInputParams();
                    if (!routeSearchParams) {
                        routeSearchParams = new RouteSearchParams();
                    }

                    if (surroundType === POISurroundType.type_route_endPOI) {
                        let endPOIInfo = RoutePOIInfo.createEndPoint();
                        endPOIInfo.POI = addressPOI;
                        endPOIInfo.description = "终点：" + addressPOI.name;
                        endPOIInfo.suggestKey = addressPOI.name;

                        routeSearchParams.endPoint = endPOIInfo;
                    }
                    else if (surroundType === POISurroundType.type_route_startPOI) {

                        let startPOIInfo = RoutePOIInfo.createStartPoint();
                        startPOIInfo.POI = addressPOI;
                        startPOIInfo.description = "起点：" + addressPOI.name;
                        startPOIInfo.suggestKey = addressPOI.name;
                        routeSearchParams.startPoint = startPOIInfo;
                    }
                    else if (surroundType === POISurroundType.type_route_viaPOI) {

                        let viaPnt = RoutePOIInfo.createViaPoint();
                        viaPnt.POI = addressPOI;
                        viaPnt.description = "途径点：" + addressPOI.name;
                        viaPnt.suggestKey = addressPOI.name;
                        if (!routeSearchParams.driveViaPoints) {
                            routeSearchParams.driveViaPoints = new Array();
                        }

                        //最多添加5个途径点，与国家天地图保持一致
                        if (routeSearchParams.driveViaPoints && routeSearchParams.driveViaPoints.length < 5) {
                            routeSearchParams.driveViaPoints.push(viaPnt);
                        }


                    }

                    self.ucSideBar.showModule(UCModuleItemType.routeline, routeSearchParams);
                    self.ucMap.layerMgr.clearMarkers();
                }


            }, function (error) {



            });



        });



        this.ucMap.on_moveend(function () {
            let mapExtent = self.ucMap.getMapExtent();
            let mapLevel = self.ucMap.getZoomLevel();

            self._ucDistrictCityChange(mapLevel, mapExtent);
        }
        );

        ////级别改变
        this.ucMap.on_zoomLevelChange(function (curLevel) {


            self._ucZoomControl_zoomLevelChange(curLevel);

            //刷新地图左下角的比例尺
            let resolution = self.ucMap.getResolution();
            self.ucMapBottomLeft.refreshScale(resolution);

        });



    }

    _addZoomControlListener() {
        let self = this;

        this.ucZoomControl.on_zoomLevelDoubleClick(function () {
            self.ucMap.plusZoomLevel();
        });


        this.ucZoomControl.on_zoomInClick(function () {
            self.ucMap.plusZoomLevel();

        });

        this.ucZoomControl.on_zoomOutClick(function () {
            self.ucMap.subtractionZoomLevel();
        });

    }

    _ucZoomControl_zoomLevelChange(mapLevel) {
        this.ucZoomControl.changeZoomLevel(mapLevel);
    }

    /**
     * 添加poi标记点
     * @param {*} pois 
     */
    _addpoiMarkers(pois) {
        this.ucMap.layerMgr.clearPOISearchLayer();

        if (!pois || pois.length == 0) return;

        this.ucMap.layerMgr.poiSearchLayer.addMarkers(pois);

        //修改地图范围
        let coordinates = POIResultItems.getPOICoordinates(pois);
        let transformCoordinates = null;
        
        let mapCRSCode = this.ucMap.getProjectionCode();
        let poiCRSCode = pois[0].crsCode;
        if (mapCRSCode !== poiCRSCode) {
            transformCoordinates = GeometryUtility.transformPoints(coordinates, poiCRSCode, mapCRSCode);
        }
        else {
            transformCoordinates = coordinates;
        }

        if (transformCoordinates.length > 1) {
            let poiExtent = GeometryExtentUtility.GetExtent(transformCoordinates);
            poiExtent = GeometryExtentUtility.expandExtent(poiExtent, 1.5);
            this.ucMap.setMapExtent(poiExtent);
        }
        else {
            let firstPnt = transformCoordinates[0];
            this.ucMap.setCenter(15, firstPnt);
        }

    }

    /**
     * 定位poi标记点
     * @param {*} curPoi 
     */
    _locationPoiMarker(curPoi) {
        let mapZoom = 13;

        let curMapZoomLevel = this.ucMap.getZoomLevel();
        if (curMapZoomLevel > mapZoom) {
            mapZoom = curMapZoomLevel;
        }

        let centerPnt = [curPoi.x, curPoi.y];

        let mapCRSCode = this.ucMap.getProjectionCode();
        let poiCRSCode = curPoi.crsCode;
        if (mapCRSCode !== poiCRSCode) {
            //投影转换
            centerPnt = ol.proj.transform(
                centerPnt,
                poiCRSCode,
                mapCRSCode
            );
        }

        //影响气泡显示，暂时先隐藏
        // let initFeature = POISearchLayer.createInitFeature(curPoi);
        // this.ucMap.showOverlay(centerPnt, initFeature);

        this.ucMap.setCenter(mapZoom, centerPnt);
    }

    /**
     * 改变表基地单样式
     * @param {*} curPoi 
     */
    _changeFocusPoiMarkerStyle(curPoi) {
        this.ucMap.layerMgr.poiSearchLayer.changeCurrentPOIStyle(curPoi);
    }

    /**
     * 添加路线要素
     * @param {*} route 
     */
    _addDriveRouteLineFeature(route) {
        if (!route) return;

        let mapCode = this.ucMap.getProjectionCode();
        let routeCRSCode = route.crsCode;

        let latlon = route.routelatlon;

        let pntStrings = latlon.split(";");

        let pnts = GeometryUtility.getPoints(pntStrings);
        let transfermPnts = pnts;
        if (mapCode !== routeCRSCode) {
            transfermPnts = GeometryUtility.transformPoints(pnts, routeCRSCode, mapCode);
        }

        let midPntsString = route.mid;
        let midPntStrings = midPntsString.split(";");

        //途经点
        let viaPnts = GeometryUtility.getPoints(midPntStrings);
        let transfermViaPnts = viaPnts;
        if (mapCode !== routeCRSCode) {
            transfermViaPnts = GeometryUtility.transformPoints(viaPnts, routeCRSCode, mapCode);
        }


        this.ucMap.layerMgr.clearMarkers();
        this.ucMap.layerMgr.routeLayer.addDriveRouteLine(transfermPnts, transfermViaPnts);

        let mapExtent = GeometryExtentUtility.GetExtent(transfermPnts);
        mapExtent = GeometryExtentUtility.expandExtent(mapExtent, 1.5);
        this.ucMap.setMapExtent(mapExtent);

        // this.ucMap.setCenter(mapZoom, centerPnt);
    }

    /**
     * 添加线路选择要素
     * @param {*} routeItem 
     */
    _addDriveRouteSelectLineFeature(routeItem) {
        if (!routeItem) return;

        let latlon = routeItem.streetLatLon;

        let pntStrings = latlon.split(";");

        //坐标转换
        // let centerPnt = GeometryExtentUtility.getCenterPointEx(pntStrings);

        let mapCode = this.ucMap.getProjectionCode();
        let routeCRSCode = routeItem.crsCode;

        // if (mapCode !== routeCRSCode) {
        //     centerPnt = ol.proj.transform(
        //         centerPnt,
        //         routeCRSCode,
        //         mapCode
        //     );
        // }


        // let mapZoom = 13;
        // let curMapZoomLevel = this.ucMap.getZoomLevel();
        // if (curMapZoomLevel > mapZoom) {
        //     mapZoom = curMapZoomLevel;
        // }

        let pnts = GeometryUtility.getPoints(pntStrings);


        let transfermPnts = pnts;
        if (mapCode !== routeCRSCode) {
            transfermPnts = GeometryUtility.transformPoints(pnts, routeCRSCode, mapCode);
        }


        this.ucMap.layerMgr.routeLayer.addDriveSelectLine(transfermPnts);

        let mapExtent = GeometryExtentUtility.GetExtent(transfermPnts);
        mapExtent = GeometryExtentUtility.expandExtent(mapExtent, 1.5);
        this.ucMap.setMapExtent(mapExtent);

        // this.ucMap.setCenter(mapZoom, centerPnt);


    }

    /**
     * 添加公交线要素
     * @param {*} lineItem 
     */
    _addBusLineFeature(lineItem) {
        let self = this;

        self.ucMap.layerMgr.clearMarkers();
        if (!lineItem) return;

        self.ucMap.layerMgr.routeLayer.addBusLineItem(lineItem);

        //设置地图范围
        let pnts = lineItem.segments.getSegmentLinePoints();
        let segmentItemCode = lineItem.crsCode;
        let mapCode = self.ucMap.getProjectionCode();
        if (segmentItemCode !== mapCode) {
            pnts = GeometryUtility.transformPoints(pnts, segmentItemCode, mapCode);
        }

        let mapExtent = GeometryExtentUtility.GetExtent(pnts);
        mapExtent = GeometryExtentUtility.expandExtent(mapExtent, 1.5);

        self.ucMap.setMapExtent(mapExtent);
    }

    /**
     * 添加公交线段要素
     * @param {*} segmentItem 
     */
    _addBusSegmentFeature(segmentItem) {
        let self = this;

        self.ucMap.layerMgr.routeLayer.addBusSegmentItem(segmentItem);

        //设置地图范围
        let pnts = segmentItem.lines.getPoints();
        let segmentItemCode = segmentItem.crsCode;
        let mapCode = self.ucMap.getProjectionCode();
        if (segmentItemCode !== mapCode) {
            pnts = GeometryUtility.transformPoints(pnts, segmentItemCode, mapCode);
        }

        let mapExtent = GeometryExtentUtility.GetExtent(pnts);

        mapExtent = GeometryExtentUtility.expandExtent(mapExtent, 1.5);

        self.ucMap.setMapExtent(mapExtent);

    }

    _focusedBusSegmentEnd(segmentItem) {
        let self = this;

        //隐藏，因为 在添加线路的时候，已经添加了marker站点
        // self.ucMap.layerMgr.routeLayer.focusedBusSegmentEnd(segmentItem);

        let stationEnd = segmentItem.stationEnd;
        let stationPoint = [stationEnd.lon, stationEnd.lat];

        let mapCode = this.ucMap.getProjectionCode();
        let segmentCRSCode = segmentItem.crsCode;
        if (segmentCRSCode !== mapCode) {
            stationPoint = GeometryUtility.transformPoints(stationPoint, segmentCRSCode, mapCode);
        }

        let initFeature = RouteLayer.createBusSegmentEndInitFeature(null, segmentItem);
        self.ucMap.showOverlay(stationPoint, initFeature);

    }


    _ucDistrictCityChange(mapLevel, mapExtent) {
        this.ucNavBar.ucDistrictCityChange(mapLevel, mapExtent);
    }


    /**
     * 添加收藏项
     * @param {*} curFolder 
     * @param {*} drawItem 
     * @param {*} succeedCallback 
     * @param {*} errorCallback 
     */
    _addCollectItemHandler(curFolder, drawItem, succeedCallback, errorCallback) {

        let curCollectItem = new UserCollectItem();
        if (drawItem) {
            curCollectItem.name = drawItem.name;
            curCollectItem.content = drawItem.getJsonString();
            curCollectItem.type = drawItem.type;
        }

        if (curFolder) {
            curCollectItem.folderId = curFolder.id;
        }


        if (TdtUser.currentUser) {
            curCollectItem.userId = TdtUser.currentUser.name;
        }


        curCollectItem.createTime = DateUtility.getyyyyMMddhhmmss()

        let createUrl = ServiceUrlConfig.platform_collectitem_add;


        curCollectItem.create(createUrl, function (response) {
            succeedCallback(response);
        },

            function (error) {
                errorCallback(error);
            }
        );


    }



}

